import { snakeCase } from 'lodash';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker } from 'components/atoms/date-picker';
import { Menu } from 'components/atoms/dropdown';
import { Radio } from 'components/atoms/radio';
import {
  DateFieldFilterOperationType,
  DateFieldFilter,
  DateFieldAbsoluteFilter,
} from '../../filters/date';
import { Lines, Line } from './components';

export const renderAbsoluteMenuItem = (
  filter: DateFieldFilter,
  type: DateFieldFilterOperationType,
  onChange: (filter: DateFieldFilter) => void,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | JSX.Element,
) => (
  <Menu.Item key={type.toString()} className="date-criteria">
    <Lines>
      <Line>
        <Radio checked={filter.type === type} />{' '}
        {getOperationOptionRenderer?.(type) ?? (
          <FormattedMessage
            id={`task_list.filters.${snakeCase(
              DateFieldFilterOperationType[type],
            )}`}
          />
        )}
      </Line>
      {filter.type === type && (
        <Line>
          <DatePicker
            autoFocus
            value={(filter as DateFieldAbsoluteFilter).value}
            onChange={(latest) =>
              onChange({
                ...filter,
                value:
                  latest == null
                    ? null
                    : moment.utc(`${latest.format('YYYY-MM-DD')}T00:00:00Z`),
              } as DateFieldFilter)
            }
            allowClear={false}
          />
        </Line>
      )}
    </Lines>
  </Menu.Item>
);
